import React, { useState, useEffect, useRef } from "react";
import "../PopularTest/styles.scss";
import {
  Card,
  CardSelectTest,
  CardSelectedTest,
  MobileCardSelectedTest,
  SliderComponent,
  Toast,
} from "../../components";
import { useSelector } from "react-redux";
import dropdown1 from "../../assets/images/dropdown.svg";
import { Modal } from "react-bootstrap";
import { Popup, Filter } from "../../components";
import _ from "lodash";
import Layout from "../../layout";
import Search from "../../assets/images/search.svg";
import idea from "../../assets/images/idea1.svg";
import logos1 from "../../assets/images/logos1.svg";
import logos2 from "../../assets/images/logos2.svg";
import ficon from "../../assets/images/popularS.svg";
import logos4 from "../../assets/images/logos4.svg";
import logos5 from "../../assets/images/logos5.svg";
import ArrowLeft from "../../assets/images/Arrow-left.svg";
import One from "../../assets/images/one.svg";
import Two from "../../assets/images/two.svg";
import Three from "../../assets/images/three.svg";
import Chat from "../../components/Chat/Chat";
import home from "../../assets/images/HomeDisable.svg";
import rightArr from "../../assets/images/navRight.svg";
import doctall from "../../assets/images/doctall.svg";
import axios from "../../redux/axios";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import {
  testValue,
  removeTest,
  featureRemoveTest,
  clearTest,
  clearSearch,
  areaValue,
} from "../../redux/auth/actions";
import left from "../../assets/images/left.svg";
import right from "../../assets/images/right.svg";
import Backicon from "../../assets/images/mobback.svg";
import Stepone from "../../assets/images/stepone.svg";
import Steptwo from "../../assets/images/steptwo.svg";
import Sheet from "react-modal-sheet";
import {
  getCities,
  getPartners,
} from "../recommended-tests/services/recommendedTestsServices";
import LoaderComponent from "../../components/Loading/LoaderComponent";
import LongDurationToast from "../../components/long-duration-toast/LongDurationToast";
import CryptoJS from "crypto-js";
export default function SearchResultPage(props) {
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );
  const areaState = useSelector((state) =>
    state.area != undefined && state.area.area != undefined
      ? state.area.area
      : ""
  );

  const [ShowLocation, setShowLocation] = useState(false);
  const [selectedRec, setSelectedRec] = useState([]);
  const [update, setUpdate] = useState(false);
  const [ShowArea, setShowArea] = useState(false);
  const [rangeFilter, setRangFilter] = useState("A-Z");
  const [arrIndex, setArrIndex] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [testData, setTestData] = useState([]);
  const [filterValue, setFilterValue] = useState("pathology");
  const [inputSearch, setInputSearch] = useState("");
  const [btn, setBtn] = useState(false);
  const [btmLocationSheet, setbtmLocationSheet] = useState(false);
  const [city, setCity] = useState([]);
  const [testListing, setTestListing] = useState([]);
  const [allTestRange, setAllTestRange] = useState("A-Z");
  const [count, setCount] = useState(0);
  const [locPop, setLocPop] = useState(false);
  const [pageno, setPageno] = useState(0);
  const [partner, setPartner] = useState([]);
  const [area, setArea] = useState("");
  const [mobileView, setMobileView] = useState(false);
  const [testDatas, setTestDatas] = useState([]);
  const [singleSearchData, setSingleSearchData] = useState([]);
  const [perticularTestName, setPerticularTestName] = useState("");
  const [mobileTestpopstate, setMobiletestpopstate] = useState(false);
  const dispatch = useDispatch();
  const [areaId, setAreaId] = useState("");
  const sheetRef = useRef();
  const [btmSheet, setbtmSheet] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [noDataError, setNoDataError] = useState(false);
  const test = useSelector((state) => state);
  const history = useHistory();
  const lanTestes = history.location.state;
  const arealocal = useSelector((state) => state.area);
  const globalSearchAll = useSelector((state) => state.auth.allSearch);
  const globalSearch = useSelector((state) => state.auth.search);
  const searchKey = useSelector((state) => state.auth.searchKeywords);
  const [loading, setLoading] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [diffId, seDiffId] = useState("");
  const [dummy, setDummy] = useState(true);

  const searchKeyval = history.location;

  const searchKeyArray = searchKeyval.search.split("&");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let testId = "";
  let testName = "";
  let decryptedData = "";
  if (searchKeyArray.length > 0) {
    testId = searchKeyArray[1];
    testName = searchKeyArray[0]?.replaceAll("-", " ")?.replaceAll("?=", "");
    if (testId) {
      let bytes = CryptoJS.AES.decrypt(testId, "my-secret-key@123");
      decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
  }
  // alert(decryptedData);
  // alert(testName);
  // console.log(decryptedData, "decryptedData--- testName", testName);
  // const [userTestId, setUserTestId] = useState(decryptedData);
  // const [userTestname, setUsertestname] = useState(testName);
  // useEffect(() => {
  //   setUserTestId(globalSearch?.uuid);
  //   setUsertestname(globalSearch?.name);
  //   setDummy(!dummy);
  // }, [globalSearch]);

  // console.log(globalSearch?.uuid, "decryptedData");
  useEffect(() => {
    fetchCities();
    fetchPartners();
  }, []);

  useEffect(() => {
    setTestData([]);
    if (testName) {
      let userTestnamearray = testName.split(" ");
      getAlltheTestByLocation(userTestnamearray[0]);
    }
    let data = [];
    if (arealocal.area.value === "") {
      setTestDatas(globalSearchAll);

      if (window.location.pathname !== "/search-results") {
        window.scrollTo(0, 500);
        setShowLocation(true);
      }
    } else {
      if (searchKey) {
        getAlltheTestByLocation(searchKey);
      }
    }
  }, [globalSearchAll, arealocal, searchKey, globalSearch, testName]);

  const getAlltheTestByLocation = (searchKeyName) => {
    setTestDatas([]);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists/filter?value=${searchKeyName}&area=${arealocal.area.value}`
      )
      .then((res) => {
        if (res.status === 200 && res.data.data) {
          setTestDatas(res.data.data);
        } else {
          setTestDatas([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error && error.response) {
          setToastOpen(true);
          setToastMessage("");
        }
        setTestDatas([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    setSingleSearchData([]);
    setTestDatas([]);
    setPerticularTestName("");
    setTimeout(() => {
      setPerticularTestName("");
      if (decryptedData !== undefined) {
        if (decryptedData !== undefined) {
          setLoading(true);
          if (decryptedData.charAt(1) === "R") {
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/labtest/diagnostic/centeralized/search?type=radiology&value=${decryptedData}&area=${arealocal.area.value}&filter=${rangeFilter}&pagenum=0&limit=10`
              )
              .then((res) => {
                if (res.status === 200 && res.data.data) {
                  setSingleSearchData(res.data.data);
                  setToastOpen(false);
                  let message = `Search Result For (${testName})`;
                  setPerticularTestName(message);
                  if (searchKey) {
                    getAlltheTestByLocation();
                  }
                } else {
                  setToastOpen(true);
                  // setToastMessage("No Search Result Found For" + testName);
                  setSingleSearchData([]);
                  let message = `No Search Result Found For (${testName})`;
                  setPerticularTestName(message);
                }
                setLoading(false);
              })
              .catch((error) => {
                if (error && error.response) {
                  setToastOpen(true);
                  setToastMessage("" + error.response.data);
                }
                setLoading(false);
              });
          } else {
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/labtest/diagnostic/centeralized/search?type=pathology&value=${decryptedData}&area=${arealocal.area.value}&filter=A-Z&pagenum=0&limit=8`
              )
              .then((res) => {
                if (res.status === 200 && res.data.data) {
                  setSingleSearchData(res.data.data);
                  setToastOpen(false);
                  let message = `Search Result For (${testName})`;
                  setPerticularTestName(message);
                } else {
                  setTestDatas([]);
                  setToastOpen(true);
                  // setToastMessage("No Search Result Found");
                  let message = `No Search Result Found For (${testName})`;
                  setPerticularTestName(message);
                }
                setLoading(false);
              })
              .catch((error) => {
                if (error && error.response) {
                  setToastOpen(true);
                  // + error.response.data
                  // setToastMessage("No Result Found");
                }
                setLoading(false);
              });
          }
        }
      }
    }, 500);
  }, [decryptedData, testName, arealocal]);

  const fetchCities = async () => {
    try {
      let response = await getCities();
      setCity(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPartners = async () => {
    try {
      let response = await getPartners();
      setPartner(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (areaState.value === undefined) {
      setAreaId("");
    } else {
      setAreaId(areaState.value);
    }
  }, [areaState]);

  const handleLocPop = () => {
    window.scrollTo(0, 400);
    ShowLocation === true ? setShowLocation(false) : setShowLocation(true);
  };

  const selectTest = (i, value) => {
    if (arealocal.area.value === "") {
      dispatch(clearTest());
      setShowLocation(true);
    } else {
      setShowLocation(false);
      selectedRec.push(value);
      dispatch(testValue(value));
      arrIndex.push(i);
      setUpdate(!update);
    }
  };

  const delSelectedTest = (v) => {
    const newArr = selectedRec.filter((object) => {
      return object.doc?.uuid !== v.doc.uuid;
    });
    setSelectedRec(newArr);
    dispatch(removeTest(v.doc.uuid));
  };

  const handlleRemoveTest = (v) => {
    dispatch(featureRemoveTest(v.uuid));
  };

  const handleLocationClose = () => {
    setShowLocation(false);
  };

  const handleAreaClose = () => {
    setShowArea(false);
  };

  useEffect(() => {
    if (lanTestes) {
      let data = selectedRec.concat(lanTestes);
      setSelectedRec(data);
      setUpdate(!update);
    }
  }, []);

  const handleCount = (v) => {
    const result = count + v;
    setTestListing([]);
    if (result > 0) {
      setCount(result);
    } else {
      setCount(0);
    }
  };

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 600
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const handlemobileTestpop = () => {
    setMobiletestpopstate(false);
  };

  const handlePopupClose = () => {
    setToastOpen(false);
  };

  const phoneNumber = "+2349010996000";
  const boldStyle = {
    fontWeight: 'bold',
    cursor: "grab",
    color: "#ff5c3c",
    fontSize: "15px"
  };

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <>
      {loading && <LoaderComponent />}
      <LongDurationToast
        text={toastMessage}
        type="error"
        // open={toastOpen}
        setClose={() => {
          setToastOpen(false);
        }}
      />

      <Modal
        show={toastOpen}
        onHide={handlePopupClose}
        style={{ marginLeft: "8%" }}
      >
        <div className="parentContainer" style={{ marginTop: "253px", width: "113%" }}>
          <div style={{ marginTop: "200px !important", zIndex: "10000000 !important" }}>
            <div>
              <p>We couldn't find any results for your search. Contact our team on WhatsApp at <a target="" onClick={handleWhatsAppClick} style={boldStyle}>{phoneNumber}</a> for assistance. We're here to help!</p>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              className="popup_btn"
              style={
                { backgroundColor: "#FF5C3", display: "flex", justifyContent: "center" } //opacity: "0.5", cursor: "not-allowed"
              }
              onClick={() => {
                setToastOpen(false);
              }}
            >
              Close
            </div>
          </div>
        </div>
      </Modal>

      <Layout>
        <div className="popularContainer">
          {!mobileView ? (
            <>
              <div className="title" style={{ margin: "2% 2% 0% 2%" }}>
                <img
                  src={home}
                  alt="icon"
                  onClick={() => {
                    history.push("/");
                  }}
                />
                <img src={rightArr} alt="icon" />
                Search Result
              </div>
              {/* <div className="steps_to_follow">
                <div className="header">SEARCHED TEST</div>
              </div> */}
            </>
          ) : (
            <div className="mobile-view-popular-outer-cls">
              <div
                className="header-back-row"
                onClick={() => {
                  history.goBack();
                }}
              >
                <img src={Backicon} alt="Backicon" />
                <div className="back-text">Back</div>
              </div>
            </div>
          )}
          <div className="page_container">
            <div className="input_containerrr" style={{ marginTop: "0px" }}>
              <div className="leftContainer">
                <div className="heading_container">
                  <div className="heading"></div>
                  <div className="txt">
                    {/* Browse through our common/popular tests */}
                  </div>
                </div>
                <div className="filter_container"></div>
              </div>
              {!mobileView && (
                <div className="right_container">
                  <span>Set Location</span>
                  {cityState.label !== "" && areaState.label !== "" ? (
                    <div
                      className="location"
                      onClick={() => {
                        window.scrollTo(0, 400);
                        setShowLocation(true);
                      }}
                    >
                      <span style={{ fontSize: "14px" }}>
                        City: {cityState.label}
                      </span>{" "}
                      <span style={{ fontSize: "14px" }}>
                        Area: {areaState.label}
                      </span>
                      {/* City:{cityState.label} Area:{areaState.label} */}
                      <span>
                        <div className="right-cont-outer">
                          <div className="left-cls" style={{ color: "#163e8c", alignItems: "left", fontSize: "14px" }}><b>EDIT</b></div>
                        </div>
                      </span>
                    </div>
                  ) : (
                    <div
                      className="location"
                      onClick={() => setShowLocation(true)}
                    >
                      <br></br>
                      Search and set your location
                      <img src={dropdown1} alt="icon" />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="Card_container_list">
              {
                <h5>
                  {singleSearchData &&
                    singleSearchData.length !== 0 &&
                    perticularTestName}{" "}
                </h5>
              }
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "wrap",
                  width: "100%",
                  gap: "12px",
                }}
              >
                {singleSearchData && singleSearchData.length !== 0
                  ? singleSearchData.map((value, i) => (
                    <CardSelectTest
                      index={i}
                      key={i}
                      val={value}
                      heading={value.doc.standardisedtestname}
                      subHeading={value.doc.partnerstestname}
                      des={value.doc.populartestdescription}
                      dumb={value.doc.testname_uuid}
                      handleItems={selectTest}
                      handleItemDelete={delSelectedTest}
                      cardType={"SEARCH"}
                    />
                  ))
                  : ""}
              </div>

              {/* {noDataError && <h5>No Tests Found For The Saved/Selected Location !</h5>} */}

              <div className="pathologyCardList">
                {testDatas && testDatas.length !== 0 && (
                  <h5>Browse through your search related tests</h5>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "wrap",
                    width: "100%",
                    gap: "12px",
                  }}
                >
                  {testDatas && testDatas.length !== 0
                    ? testDatas.map((value, i) => (
                      <>
                        {decryptedData !== value.doc.testname_uuid && (
                          <CardSelectTest
                            index={i}
                            key={i}
                            val={value}
                            heading={value.doc.standardisedtestname}
                            subHeading={value.doc.partnerstestname}
                            des={value.doc.populartestdescription}
                            handleItems={selectTest}
                            handleItemDelete={delSelectedTest}
                            dumb={value.doc.testname_uuid}
                          />
                        )}
                      </>
                    ))
                    : ""}
                </div>

                {showCard ? (
                  <>
                    {" "}
                    {testListing && testListing.length !== 0
                      ? testListing.data.map((value, i) => (
                        <CardSelectTest
                          index={i}
                          key={i}
                          val={value}
                          heading={value.doc.standardisedtestname}
                          subHeading={value.doc.partnerstestname}
                          des={value.doc.populartestdescription}
                          handleItems={selectTest}
                          handleItemDelete={delSelectedTest}
                        />
                      ))
                      : ""}
                  </>
                ) : (
                  ""
                )}
                <div className="pagination_container">
                  {showCard && (
                    <div className="page_container">
                      <div className="left_btn" onClick={() => handleCount(-1)}>
                        <img src={left} alt="icon" />
                      </div>
                      <div className="no_container">
                        Page <span>{count}..</span> of{" "}
                        {testListing && testListing.count !== undefined
                          ? testListing.count
                          : ""}
                      </div>
                      <div className="right_btn" onClick={() => handleCount(1)}>
                        <img src={right} alt="icon" />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {(!mobileView && (
                <CardSelectedTest
                  type="popular_test"
                  list={selectedRec}
                  del={delSelectedTest}
                  featuredel={handlleRemoveTest}
                  area={area}
                  handleLocPop={handleLocPop}
                />
              )) ||
                ""}
            </div>
          </div>
        </div>
        {(!mobileView && (
          <div className="container_work">
            <div className="heading">How it works?</div>
            <div className="text">Get your medical tests in 3-simple steps</div>
            <Card />
          </div>
        )) ||
          ""}
        <SliderComponent />
        {(!mobileView && (
          <div className="trustpar">
            <div className="by">
              OUR PARTNERS
            </div>
            <div className="imgc">
              {/* Need to style the images, */}
              {partner &&
                partner.map((partner) => (
                  <div>
                    <img
                      style={{ height: "20px", width: "45px" }}
                      src={partner.logo}
                      alt="icon"
                    />
                  </div>
                ))}
            </div>
          </div>
        )) ||
          ""}
        <Sheet
          isOpen={btmSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <MobileCardSelectedTest
                type="popular_test"
                onClose={() => {
                  setbtmSheet(false);
                }}
                list={selectedRec}
                del={delSelectedTest}
                featuredel={handlleRemoveTest}
                area={area}
              />{" "}
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>

        {(mobileView && (
          <>
            {/* <Sheet
              isOpen={btmLocationSheet}
              snapPoints={[600, 400, 100, 0]}
              onClose={() => setbtmLocationSheet(false)}
            > */}
            {/* <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content> */}
            <Modal
              show={btmLocationSheet}
              onHide={() => setbtmLocationSheet(false)}
            >
              <Popup
                city={city}
                setShowLocation={() => {
                  setbtmLocationSheet(false);
                  setbtmSheet(true);
                }}
                setArea={setArea}
                setSelectedRec={setSelectedRec}
              />
            </Modal>

            {/* </Sheet.Content>
              </Sheet.Container>

              <Sheet.Backdrop /> */}
            {/* </Sheet> */}
            <FloatingIcon
              onClick={() => {
                // window.scroll(0, 0);
                area.length == 0
                  ? setbtmLocationSheet(true)
                  : setbtmSheet(true);
                // setShowLocation(true);
              }}
              count={selectedRec.length}
            />
          </>
        )) ||
          ""}
        <Modal show={ShowArea} onHide={handleAreaClose}>
          <Filter />
        </Modal>
        <Modal show={ShowLocation} onHide={handleLocationClose}>
          <Popup
            city={city}
            setShowLocation={setShowLocation}
            setArea={setArea}
            setSelectedRec={setSelectedRec}
          />
        </Modal>
        <Modal show={mobileTestpopstate} onHide={handlemobileTestpop}>
          <Popup
            city={city}
            setShowLocation={setShowLocation}
            setArea={setArea}
          />
        </Modal>
        {/* <Chat /> */}
      </Layout>
    </>
  );
}
const FloatingIcon = (props) => {
  return (
    <div className="floatingIcon" onClick={() => props.onClick()}>
      <div className="count">{props.count}</div>
      <img src={ficon} />
      {(props.count == 0 && <div className="foverlay"></div>) || ""}
    </div>
  );
};
